<template v-if="user">
  <span>
    <v-navigation-drawer app dark v-model="drawer">
      <v-list>
        <template v-for="(item, index) in activeItems">
          <v-list-tile
            v-if="!item.childs"
            active-class
            dark
            :key="index"
            :to="item.target"
            @click="onItemClick(item)"
          >
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{$t(item.title)}}</v-list-tile-title>
          </v-list-tile>
          <v-list-group v-else :key="index" no-action>
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon>{{item.icon}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>{{$t(item.title)}}</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(subitem, i) in item.childs"
              :key="i"
              :to="subitem.target"
              @click="onItemClick(subitem)"
              active-class
            >
              <v-list-tile-title>{{subitem.title}}</v-list-tile-title>
              <v-list-tile-action>
                <v-icon>{{subitem.icon}}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app dark>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{appTitle}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<server-status></server-status>-->
      <language-control/>
    </v-toolbar>
  </span>
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '../events/EventBus';
import Auth from '@aws-amplify/auth';
//import ServerStatus from './ServerStatus';
import LanguageControl from './LanguageControl';

export default {
  name: 'AppNavigation',
  components: {
    //ServerStatus,
    LanguageControl
  },
  data() {
    return {
      appTitle: 'ipWay',
      drawer: undefined,
      items: [
        {
          title: 'menu.home',
          target: '/',
          icon: 'home',
          public: true
        },
        {
          title: 'menu.calls',
          target: '/calls',
          icon: 'call'
        },
        {
          title: 'menu.info',
          target: '/account',
          icon: 'account_circle'
        },
        {
          title: 'menu.logout',
          action: 'logout',
          icon: 'exit_to_app'
        }
      ]
    };
  },
  computed: {
    activeItems: function() {
      return this.items.filter(item => {
        if (this.user) return true;
        return item.public;
      });
    },
    ...mapState('awsauth', ['user'])
  },
  methods: {
    logout() {
      Auth.signOut()
        .then(() => {
          console.log('signout success');
          return EventBus.$emit('authState', 'signedOut');
        })
        .catch(e => console.error(e));
    },
    onItemClick(item) {
      if (item && 'action' in item) {
        switch (item.action) {
          case 'logout':
            this.logout();
            break;
        }
      }
    }
  }
};
</script>
<style scoped>
</style>